import '../../assets/index44.css';var ie = Object.defineProperty, ne = Object.defineProperties;
var de = Object.getOwnPropertyDescriptors;
var x = Object.getOwnPropertySymbols;
var A = Object.prototype.hasOwnProperty, F = Object.prototype.propertyIsEnumerable;
var q = (t, o, e) => o in t ? ie(t, o, { enumerable: !0, configurable: !0, writable: !0, value: e }) : t[o] = e, a = (t, o) => {
  for (var e in o || (o = {}))
    A.call(o, e) && q(t, e, o[e]);
  if (x)
    for (var e of x(o))
      F.call(o, e) && q(t, e, o[e]);
  return t;
}, c = (t, o) => ne(t, de(o));
var G = (t, o) => {
  var e = {};
  for (var s in t)
    A.call(t, s) && o.indexOf(s) < 0 && (e[s] = t[s]);
  if (t != null && x)
    for (var s of x(t))
      o.indexOf(s) < 0 && F.call(t, s) && (e[s] = t[s]);
  return e;
};
import { jsx as n, jsxs as J } from "react/jsx-runtime";
import { useContext as ue, createContext as he, forwardRef as pe, useState as me } from "react";
import { f as Q, u as T, e as be, B as O, h as _e, c as we } from "../../factory-ueRxoNOV.js";
import { Label as fe } from "../Label/index.js";
import { c as I, e as Se } from "../../get-size-Bc1Pz5yf.js";
import { c as ke } from "../../create-vars-resolver-Bzbn9G-G.js";
import { u as ve } from "../../use-styles-DToiHEa6.js";
import { I as ye, a as Ce, b as ge } from "../../InputsGroupFieldset-Bo-BOy1U.js";
import { I as X } from "../../Input--FNE961U.js";
import { u as D } from "../../use-uncontrolled-BT_j5D2R.js";
import { u as Ie } from "../../use-id-D2tGiO9x.js";
const H = he(null), Pe = H.Provider, xe = () => ue(H), Ge = {}, V = Q((t, o) => {
  const m = T("SwitchGroup", Ge, t), { value: e, defaultValue: s, onChange: d, size: r, wrapperProps: l, children: u, readOnly: S } = m, k = G(m, ["value", "defaultValue", "onChange", "size", "wrapperProps", "children", "readOnly"]), [i, v] = D({
    value: e,
    defaultValue: s,
    finalValue: [],
    onChange: d
  });
  return /* @__PURE__ */ n(Pe, { value: { value: i, onChange: (y) => {
    const b = y.currentTarget.value;
    !S && v(
      i.includes(b) ? i.filter((C) => C !== b) : [...i, b]
    );
  }, size: r }, children: /* @__PURE__ */ n(
    X.Wrapper,
    c(a(a({
      size: r,
      ref: o
    }, l), k), {
      labelElement: "div",
      __staticSelector: "SwitchGroup",
      children: /* @__PURE__ */ n(ye, { role: "group", children: u })
    })
  ) });
});
V.classes = X.Wrapper.classes;
V.displayName = "@mantine/core/SwitchGroup";
var K = { root: "m_5f93f3bb", input: "m_926b4011", track: "m_9307d992", thumb: "m_93039a1d", trackLabel: "m_8277e082" };
const ze = {
  labelPosition: "right"
}, Le = ke((t, { radius: o, color: e, size: s }) => ({
  root: {
    "--switch-radius": o === void 0 ? void 0 : Se(o),
    "--switch-height": I(s, "switch-height"),
    "--switch-width": I(s, "switch-width"),
    "--switch-thumb-size": I(s, "switch-thumb-size"),
    "--switch-label-font-size": I(s, "switch-label-font-size"),
    "--switch-track-label-padding": I(s, "switch-track-label-padding"),
    "--switch-color": e ? _e(e, t) : void 0
  }
})), z = Q((t, o) => {
  var W;
  const e = T("Switch", ze, t), M = e, {
    classNames: s,
    className: d,
    style: r,
    styles: l,
    unstyled: u,
    vars: S,
    color: k,
    label: i,
    offLabel: v,
    onLabel: p,
    id: m,
    size: y,
    radius: b,
    wrapperProps: C,
    thumbIcon: P,
    checked: _,
    defaultChecked: Z,
    onChange: L,
    labelPosition: R,
    description: ee,
    error: E,
    disabled: U,
    variant: te,
    rootRef: oe,
    mod: se
  } = M, ae = G(M, [
    "classNames",
    "className",
    "style",
    "styles",
    "unstyled",
    "vars",
    "color",
    "label",
    "offLabel",
    "onLabel",
    "id",
    "size",
    "radius",
    "wrapperProps",
    "thumbIcon",
    "checked",
    "defaultChecked",
    "onChange",
    "labelPosition",
    "description",
    "error",
    "disabled",
    "variant",
    "rootRef",
    "mod"
  ]), h = xe(), ce = y || (h == null ? void 0 : h.size), g = ve({
    name: "Switch",
    props: e,
    classes: K,
    className: d,
    style: r,
    classNames: s,
    styles: l,
    unstyled: u,
    vars: S,
    varsResolver: Le
  }), { styleProps: re, rest: $ } = be(ae), j = Ie(m), w = h ? {
    checked: h.value.includes($.value),
    onChange: h.onChange
  } : {}, [B, le] = D({
    value: (W = w.checked) != null ? W : _,
    defaultValue: Z,
    finalValue: !1
  });
  return /* @__PURE__ */ J(
    Ce,
    c(a(a(c(a({}, g("root")), {
      __staticSelector: "Switch",
      __stylesApiProps: e,
      id: j,
      size: ce,
      labelPosition: R,
      label: i,
      description: ee,
      error: E,
      disabled: U,
      bodyElement: "label",
      labelElement: "span",
      classNames: s,
      styles: l,
      unstyled: u,
      "data-checked": w.checked || _ || void 0,
      variant: te,
      ref: oe,
      mod: se
    }), re), C), {
      children: [
        /* @__PURE__ */ n(
          "input",
          a(c(a({}, $), {
            disabled: U,
            checked: B,
            "data-checked": w.checked || _ || void 0,
            onChange: (N) => {
              var Y;
              h ? (Y = w.onChange) == null || Y.call(w, N) : L == null || L(N), le(N.currentTarget.checked);
            },
            id: j,
            ref: o,
            type: "checkbox",
            role: "switch"
          }), g("input"))
        ),
        /* @__PURE__ */ J(
          O,
          c(a({
            "aria-hidden": "true",
            component: "span",
            mod: { error: E, "label-position": R, "without-labels": !p && !v }
          }, g("track")), {
            children: [
              /* @__PURE__ */ n(O, c(a({ component: "span", mod: "reduce-motion" }, g("thumb")), { children: P })),
              /* @__PURE__ */ n("span", c(a({}, g("trackLabel")), { children: B ? p : v }))
            ]
          })
        )
      ]
    })
  );
});
z.classes = a(a({}, K), ge);
z.displayName = "@mantine/core/Switch";
z.Group = V;
const Ne = "Switch-module__root___Y5rbU", Ve = "Switch-module__track___gU-5z", Re = "Switch-module__input___iI5XM", Ee = "Switch-module__thumb___zlQ3T", Ue = "Switch-module__body___Y3tLM", $e = "Switch-module__label___-JqN2", f = {
  root: Ne,
  track: Ve,
  input: Re,
  thumb: Ee,
  body: Ue,
  label: $e
}, je = pe((v, i) => {
  var p = v, {
    color: t = "violet",
    classNames: o,
    checked: e,
    defaultChecked: s = !1,
    onToggle: d,
    onChange: r,
    label: l,
    variant: u = "default",
    withAsterisk: S
  } = p, k = G(p, [
    "color",
    "classNames",
    "checked",
    "defaultChecked",
    "onToggle",
    "onChange",
    "label",
    "variant",
    "withAsterisk"
  ]);
  const [m, y] = me(s), b = (P) => {
    const _ = P.currentTarget.checked;
    e === void 0 && y(_), r == null || r(P), d == null || d(_);
  }, C = typeof l == "string" ? /* @__PURE__ */ n(fe, { label: l, withAsterisk: S }) : l;
  return /* @__PURE__ */ n(
    z,
    c(a({
      classNames: c(a({}, o), {
        root: we(f.root),
        track: f.track,
        thumb: f.thumb,
        input: f.input,
        label: f.label,
        body: f.body
      }),
      checked: e != null ? e : m,
      onChange: b
    }, k), {
      color: t,
      ref: i,
      onLabel: void 0,
      offLabel: void 0,
      label: u !== "standalone" ? C : null,
      mod: { variant: u },
      wrapperProps: { "data-plum-id": k["data-plum-id"] }
    })
  );
});
je.displayName = "Switch";
export {
  je as Switch
};
